import firebase from "gatsby-plugin-firebase"

export const dbUser = uid => firebase.database().ref(`/users/${uid}`)

export const dbUserSavedList = uid =>
  firebase.database().ref(`/users/${uid}/savedList`)
export const dbUserSavedProduct = (uid, firebaseKey) =>
  firebase.database().ref(`/users/${uid}/savedList/${firebaseKey}`)

export const dbShippingAddresses = uid =>
  firebase.database().ref(`users/${uid}/shippingAddresses/`)

export const dbOrders = () => firebase.database().ref("/orders/")

export const dbUserOrders = uid =>
  firebase.database().ref(`users/${uid}/orders/`)

export const dbAcceptEmails = uid =>
  firebase.database().ref(`users/${uid}/acceptEmails/`)

export const dbViewedProducts = uid =>
  firebase.database().ref(`users/${uid}/viewedProducts/`)

export const dbViewedProduct = (uid, firebaseKey) => {
  firebase.database().ref(`users/${uid}/viewedProducts/${firebaseKey}`)
}
